import { ErrorTemplate } from '../templates';

interface IErrorProps {
  statusCode: number;
}

const SERVER_SIDE_ERROR_MESSAGE = {
  title: 'Ops, ocorreu um erro no servidor',
  text: 'Tivemos dificuldades para exibir a página que você está tentando acessar. Por favor, tente novamente mais tarde.',
};

const CLIENT_SIDE_ERROR_MESSAGE = {
  title: 'Ops, não encontramos essa página',
  text: 'Tente novamente utilizando outro termo ou palavras mais genéricas',
};

function Error({ statusCode }: IErrorProps) {
  return (
    <>
      {statusCode ? (
        <ErrorTemplate {...SERVER_SIDE_ERROR_MESSAGE} />
      ) : (
        <ErrorTemplate {...CLIENT_SIDE_ERROR_MESSAGE} />
      )}
    </>
  );
}

Error.getInitialProps = ({ res, err }) => {
  let statusCode = 404;

  if (res) {
    statusCode = res.statusCode;
  } else if (err) {
    statusCode = err.statusCode;
  }

  return { statusCode };
};

export default Error;
